import React, { memo } from 'react'
import { dayjsInit } from '@ow/utils'
import { convertTime } from '../utils'

const UserInfoPreview = ({ user, onClick }) => {
  return (
    <div className="w-80 p-2.5 text-sm">
      <div className="flex leading-7">
        <p className="w-[98px] text-right text-gray-300 flex-shrink-0">
          姓名：
        </p>
        <p className="break-all">{user?.name}</p>
      </div>
      {user?.lastInspectTime && (
        <div className="flex leading-7">
          <p className="w-[98px] text-right text-gray-300 shrink-0">
            最后上报时间：
          </p>
          <p>{dayjsInit(user.lastInspectTime).format('HH:mm')}</p>
        </div>
      )}
      {user?.totalOnlineTime && (
        <div className="flex leading-7">
          <p className="w-[98px] text-right text-gray-300 shrink-0">
            当天在线时长：
          </p>
          <p>{convertTime(user.totalOnlineTime)}</p>
        </div>
      )}
      {user?.address && (
        <div className="flex leading-7">
          <p className="w-[98px] text-right text-gray-300 shrink-0">
            当前位置：
          </p>
          <p>{user.address}</p>
        </div>
      )}
      <div
        className="text-right mt-2 text-primary-600 cursor-pointer select-none active:text-primary-800"
        onClick={() => onClick(user)}
      >
        查看详情
      </div>
    </div>
  )
}

export default memo(UserInfoPreview)
